import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  ssDialogService,
  loaderService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './edit-workstation-dialog.controller';
import template from './edit-workstation-dialog.html';


class dialogService {
  getOptions($event, {
    assessmentId, customerId, workstation, addCallback
  }) {
    return {
      controller,
      controllerAs: 'editWorkstationDialogVM',
      locals: {
        assessmentId,
        customerId,
        workstation,
        addCallback
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.editWorkstationDialog', [
  alerts,
  bcpDataService,
  constants,
  ssDialogService,
  loaderService,
])
  .service('editWorkstationDialog', dialogService)
  .name;
